const realmTimeZones: Record<string, string> = {
  be: "Europe/Brussels",
  lu: "Europe/Brussels",
  pl: "Europe/Warsaw",
  ro: "Europe/Bucharest",
  default: "UTC",
};

const getTimeZone = (realm: string): string =>
  realmTimeZones[realm] ?? realmTimeZones.default;

/**
 * formatLocalDate: Format date in the realm's local timezone
 * @param dateStr ISO string (UTC ou autre — JS le saura si suffixe)
 * @param realm realm identifier (be, pl, ro)
 */
export const formatLocalDate = (dateStr: string | number, realm: string): string => {
  if (!dateStr) return "";
  const tz = getTimeZone(realm);
  const date = new Date(dateStr); // conserve l'instant absolu
  return date
    .toLocaleString("fr-FR", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(",", "")
    .replace(/\sUTC$|\sGMT.*$/g, ""); // Remove GMT/UTC data if present
};

/**
 * formatLocalDateRange
 */
export const formatLocalDateRange = (
  startStr: string,
  endStr: string,
  realm: string
): string => {
  if (!startStr || !endStr) return "";
  const startDate = formatLocalDate(startStr, realm);
  const endDate = formatLocalDate(endStr, realm);
  return `${startDate} ${endDate}`;
};
